<template>
  <textarea
    ref="input"
    v-model="modelValue"
    :disabled="props.disabled"
    :placeholder="placeholder ? $t(placeholder) : null"
  />
</template>

<script setup>
  import { ref, watch, nextTick, computed } from 'vue';

  const props = defineProps({
    modelValue: {
      required: true,
      type: null,
    },
    autoResize: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: null,
      default: null,
    },
  });

  const emit = defineEmits(['update:modelValue']);

  const input = ref(null);

  const modelValue = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value),
  });

  watch(() => props.modelValue, () => {
    if (props.autoResize) {
      nextTick(() => {
        resize();
      });
    }
  }, { immediate: true });


  function resize() {
    const el = input.value;
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight}px`;
  }
</script>
